import { isStandalone } from "./install";

const KEY = "fm_src";
const APPS = ["futmob", "futzap", "weplay", "pipoca"];
const DISMISS = "fm_desktop_ok";

const readSrc = () => {
  const p = new URLSearchParams(window.location.search).get("src");
  const v = String(p || "").toLowerCase();
  if (v === "whatsapp" || v === "app" || APPS.some((a) => v === `app-${a}`)) {
    try { sessionStorage.setItem(KEY, v); } catch { /* ignore */ }
    return v;
  }
  try { return sessionStorage.getItem(KEY) || ""; } catch { return ""; }
};

export const isMobileDevice = () => {
  const ua = navigator.userAgent || "";
  if (navigator.userAgentData?.mobile) return true;
  if (/Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(ua)) return true;
  return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
};

/** { fonte: app_android | app_instalado | whatsapp | celular | desktop, app: futmob|futzap|weplay|pipoca|null } */
export const visitSource = () => {
  const src = readSrc();
  const app = src.startsWith("app-") ? src.slice(4) : null;
  const ua = navigator.userAgent || "";
  let fonte = "desktop";
  if (isStandalone()) fonte = "app_instalado";
  else if (src.startsWith("app") || (/Android/i.test(ua) && /; wv\)|Version\/[\d.]+ Chrome\//i.test(ua))) fonte = "app_android";
  else if (src === "whatsapp") fonte = "whatsapp";
  else if (isMobileDevice()) fonte = "celular";
  return { fonte, app };
};

export const desktopGateNeeded = () => {
  try { if (sessionStorage.getItem(DISMISS)) return false; } catch { /* ignore */ }
  return !isMobileDevice() && !isStandalone();
};

export const dismissDesktopGate = () => {
  try { sessionStorage.setItem(DISMISS, "1"); } catch { /* ignore */ }
};
